module.exports = __webpack_public_path__ + "img/logo-m.8f0918b4.svg";